import { Box } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import ReactQuill from 'react-quill';
import { ExtendedGridColDef } from 'types/datagrid';
import HtmlTooltip from 'ui-component/extended/HtmlTooltip';
import { EditInlineQuillInput } from 'ui-component/HookFormComponents/InlineEditInputComponents';

export const RichTextColumnRenderCell = ({ value }: GridRenderCellParams) => {
  if (!value) {
    return '-';
  }
  return (
    <Box
      sx={{
        alignItems: 'center',
        width: '100%',
        height: '69px',
        position: 'relative',
        display: 'flex',
      }}
    >
      <HtmlTooltip
        title={
          <ReactQuill
            value={value as string}
            readOnly
            theme="bubble"
            modules={{ toolbar: false }}
          />
        }
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            '& .ql-editor': {
              padding: 0,
              height: '100%',
              overflow: 'hidden',
            },
          }}
        >
          <ReactQuill
            value={value as string}
            readOnly
            theme="bubble"
            modules={{ toolbar: false }}
          />
        </Box>
      </HtmlTooltip>
    </Box>
  );
};

export const richTextColumnRender: Partial<ExtendedGridColDef> = {
  mutationInputElement: EditInlineQuillInput,
  renderCell: RichTextColumnRenderCell,
};
